const listPostsByStatus = (userID, nextToken="", filter="", createdAt="2020-09-10T09:22:40.952Z" ) => `
query MyCustomQuery {
  listPostsByStatus(
    status: PUBLISHED, 
    sortDirection: DESC, 
    limit: 35 ${filter} ${nextToken},
    createdAt: {ge: "${createdAt}"}
  ) {
    items {
      id
      is_video
      video_ready
      createdByID
      reactionsCount
      reactions(filter: {createdByID: {eq: "${userID}"}}) {
        nextToken
        items {
          id
          type
        }
      }
      status
      text
      commentsCount
      createdAt
      images {
        items {
          assetEntityID
          url
          id
          index
          is_video
          videoObject {
            hlsUrl
            srcHeight
            srcWidth
            thumbNailsUrls
          }
        }
      }
      userObject {
        ratePrivacy
        id
        phoneNumber
        givenName
        familyName
        numberOfVotes
        sumOfVotes
        images(limit: 1) {
          items {
            id
            index
            url
          }
        }
      }
      link {
        imageUrl
        title
        url
      }
      postTagUsers {
        items {
          user {
            id
            givenName
            familyName
            phoneNumber
            images(limit: 1) {
              items {
                id
                url
                index
              }
            }
          }
        }
      }
      postObject {
        createdByID
        reactionsCount
        status
        text
        commentsCount
        createdAt
        id
        activityObject {
          name
          activityEnd
          activityStart
          address
          description
          currency
          id
          locationDescription
          numberOfParticipants
          price
          privacy
          interest {
            id
            parentID
            title
            parentInterest {
              id
              title
            }
          }
          userObject {
            ratePrivacy
            id
            phoneNumber
            givenName
            familyName
            numberOfVotes
            sumOfVotes
            images(limit: 1) {
              items {
                id
                index
                url
              }
            }
          }
          activityAttendance {
            items {
              activityID
              createdByID
              status
              initStatus
              user {
                id
                familyName
                givenName
                phoneNumber
                images(limit: 1) {
                  items {
                    id
                    index
                    url
                  }
                }
              }
            }
          }
        }
        postTagUsers {
          items {
            user {
              id
              givenName
              familyName
              phoneNumber
              images(limit: 1) {
                items {
                  id
                  url
                  index
                }
              }
            }
          }
        }
        userObject {
          ratePrivacy
          id
          phoneNumber
          givenName
          familyName
          numberOfVotes
          sumOfVotes
          images {
            items {
              id
              index
              url
            }
          }
        }
        link {
          imageUrl
          title
          url
        }
        images {
          items {
            assetEntityID
            url
            id
            index
          }
        }
      }
      activityObject {
        status
        paymentMethod
        createdByID
        activityEnd
        activityStart
        address
        description
        currency
        id
        locationDescription
        numberOfParticipants
        price
        privacy
        interest {
          id
          parentID
          title
          parentInterest {
            id
            title
          }
        }
        userObject {
          ratePrivacy
          id
          phoneNumber
          givenName
          familyName
          numberOfVotes
          sumOfVotes
          images(limit: 1) {
            items {
              id
              index
              url
            }
          }
        }
        activityAttendance {
          items {
            activityID
            createdByID
            status
            initStatus
            user {
              id
              familyName
              givenName
              phoneNumber
              images(limit: 1) {
                items {
                  id
                  index
                  url
                }
              }
            }
          }
        }
      }
    }
    nextToken
  }
}
`;

export default listPostsByStatus;